module.exports = __webpack_public_path__ + "static/media/landelijk.a45958bc.jpg";